export const UPDATES_ICONS = {
  ok: 'check_circle',
  loading: 'hourglass_full',
  attention: 'error'
}

export const UPDATES_ICON_CLASSES = {
  ok: 'success',
  loading: '',
  attention: 'warning'
}
